import { safeParseNullDefault } from 'shouldve-been-js';
import { datetimeFromApiParser } from '../Utils/DateTimeParser';
import AppTheme from '../Enums/AppTheme';

class Order {

    private _orderId: string;
    private _orderYear: number | null;
    private _orderNo: number | null;
    private _orderPart: number | null;
    private _orderRef: string | null;
    private _priorityId: number | null;
    private _priority: string | null;
    private _priorityColor: string | null;
    private _orderTypeId: string | null;
    private _orderType: string | null;
    private _departmentId: string | null;
    private _department: string | null;
    private _localOrder: boolean | null;
    private _currencyCode: string | null;
    private _subject: string | null;
    private _supplierReference: string | null;
    private _supplierContact: string | null;
    private _budgetAccountNo: string | null;
    private _portCode: string | null;
    private _incoTerm: string | null;
    private _incoTermPlace: string | null;
    private _payTerm: string | null;
    private _shipRequestedDeliveryDate: Date | null;
    private _estimatedDeliveryDate: Date | null;
    private _deliveryAddress: string | null;
    private _approvedBy: string | null;
    private _handledBy: string | null;
    private _createdDate: Date | null;
    private _shipApprovedDate: Date | null;
    private _shipReapprovedDate: Date | null;
    private _shipOrderedDate: Date | null;
    private _receivedOfficeDate: Date | null;
    private _postponedToDate: Date | null;
    private _requisitionApprovedDate: Date | null;
    private _rfqSentDate: Date | null;
    private _awaitingApproval: Date | null;
    private _approvedDate: Date | null;
    private _officeOrderedDate: Date | null;
    private _remindedDate: Date | null;
    private _confirmedDate: Date | null;
    private _deliveredAgentDate: Date | null;
    private _sentFromAgentDate: Date | null;
    private _deliveredPoolDate: Date | null;
    private _sentFromPoolDate: Date | null;
    private _partlyDeliveredDate: Date | null;
    private _onboardDate: Date | null;
    private _invoiceDate: Date | null;
    private _invoiceApprovedDate: Date | null;
    private _cancelledDate: Date | null;
    private _finishedDate: Date | null;
    private _changedDate: Date | null;
    private _footerText: string | null;
    private _ihmStatus: string | null;
    private _costProjectId: string | null;
    private _vesselId: number | null;
    private _vesselCode: string | null;
    private _vesselName: string | null;
    private _supplierId: string | null;
    private _supplierName: string | null;
    private _agentId: string | null;
    private _agentName: string | null;
    private _statusDate: Date | null;
    private _statusText: string | null;
    private _total: number | null;
    
    public constructor(orderId: string, orderYear: number | null, orderNo: number | null, orderPart: number | null, orderRef: string | null, priorityId: number | null, priority: string | null, priorityColor: string | null, orderTypeId: string | null, orderType: string | null, departmentId: string | null, department: string | null, localOrder: boolean | null, currencyCode: string | null, subject: string | null, supplierReference: string | null, supplierContact: string | null, budgetAccountNo: string | null, portCode: string | null, incoTerm: string | null, incoTermPlace: string | null, payTerm: string | null, shipRequestedDeliveryDate: Date | null, estimatedDeliveryDate: Date | null, deliveryAddress: string | null, approvedBy: string | null, handledBy: string | null, createdDate: Date | null, shipApprovedDate: Date | null, shipReapprovedDate: Date | null, shipOrderedDate: Date | null, receivedOfficeDate: Date | null, postponedToDate: Date | null, requisitionApprovedDate: Date | null, rfqSentDate: Date | null, awaitingApproval: Date | null, approvedDate: Date | null, officeOrderedDate: Date | null, remindedDate: Date | null, confirmedDate: Date | null, deliveredAgentDate: Date | null, sentFromAgentDate: Date | null, deliveredPoolDate: Date | null, sentFromPoolDate: Date | null, partlyDeliveredDate: Date | null, onboardDate: Date | null, invoiceDate: Date | null, invoiceApprovedDate: Date | null, cancelledDate: Date | null, finishedDate: Date | null, changedDate: Date | null, footerText: string | null, ihmStatus: string | null, costProjectId: string | null, vesselId: number | null, vesselCode: string | null, vesselName: string | null, supplierId: string | null, supplierName: string | null, agentId: string | null, agentName: string | null, statusDate: Date | null, statusText: string | null, total: number | null) {

        this._orderId = orderId;
        this._orderYear = orderYear;
        this._orderNo = orderNo;
        this._orderRef = orderRef;
        this._orderPart = orderPart;
        this._priorityId = priorityId;
        this._priority = priority;
        this._priorityColor = priorityColor;
        this._orderTypeId = orderTypeId;
        this._orderType = orderType;
        this._departmentId = departmentId;
        this._department = department;
        this._localOrder = localOrder;
        this._currencyCode = currencyCode;
        this._subject = subject;
        this._supplierReference = supplierReference;
        this._budgetAccountNo = budgetAccountNo;
        this._supplierContact = supplierContact;
        this._portCode = portCode;
        this._incoTerm = incoTerm;
        this._incoTermPlace = incoTermPlace;
        this._payTerm = payTerm;
        this._shipRequestedDeliveryDate = shipRequestedDeliveryDate;
        this._approvedBy = approvedBy;
        this._handledBy = handledBy;
        this._estimatedDeliveryDate = estimatedDeliveryDate;
        this._deliveryAddress = deliveryAddress;
        this._createdDate = createdDate;
        this._shipApprovedDate = shipApprovedDate;
        this._shipReapprovedDate = shipReapprovedDate;
        this._shipOrderedDate = shipOrderedDate;
        this._receivedOfficeDate = receivedOfficeDate;
        this._postponedToDate = postponedToDate;
        this._requisitionApprovedDate = requisitionApprovedDate;
        this._rfqSentDate = rfqSentDate;
        this._awaitingApproval = awaitingApproval;
        this._approvedDate = approvedDate;
        this._officeOrderedDate = officeOrderedDate;
        this._remindedDate = remindedDate;
        this._confirmedDate = confirmedDate;
        this._deliveredAgentDate = deliveredAgentDate;
        this._sentFromAgentDate = sentFromAgentDate;
        this._deliveredPoolDate = deliveredPoolDate;
        this._sentFromPoolDate = sentFromPoolDate;
        this._partlyDeliveredDate = partlyDeliveredDate;
        this._onboardDate = onboardDate;
        this._invoiceDate = invoiceDate;
        this._invoiceApprovedDate = invoiceApprovedDate;
        this._cancelledDate = cancelledDate;
        this._finishedDate = finishedDate;
        this._changedDate = changedDate;
        this._footerText = footerText;
        this._ihmStatus = ihmStatus;
        this._costProjectId = costProjectId;
        this._vesselId = vesselId;
        this._vesselCode = vesselCode;
        this._vesselName = vesselName;
        this._supplierId = supplierId;
        this._supplierName = supplierName;
        this._agentId = agentId;
        this._agentName = agentName;
        this._statusDate = statusDate;
        this._statusText = statusText;
        this._total = total;
    }

    public get orderId(): string {
        return this._orderId;
    }

    public set orderId(value: string) {
        this._orderId = value;
    }

    public get orderYear(): number | null {
        return this._orderYear;
    }

    public set orderYear(value: number | null) {
        this._orderYear = value;
    }

    public get orderNo(): number | null {
        return this._orderNo;
    }

    public set orderNo(value: number | null) {
        this._orderNo = value;
    }

    public get orderPart(): number | null {
        return this._orderPart;
    }

    public set orderPart(value: number | null) {
        this._orderPart = value;
    }

    public get orderRef(): string | null {
        return this._orderRef;
    }

    public set orderRef(value: string | null) {
        this._orderRef = value;
    }

    public get priorityId(): number | null {
        return this._priorityId;
    }

    public set priorityId(value: number | null) {
        this._priorityId = value;
    }
    
    public get priority(): string | null {
        return this._priority;
    }

    public set priority(value: string | null) {
        this._priority = value;
    }
    
    public get priorityColor(): string | null {
        return this._priorityColor;
    }

    public set priorityColor(value: string | null) {
        this._priorityColor = value;
    }
    
    public get orderTypeId(): string | null {
        return this._orderTypeId;
    }

    public set orderTypeId(value: string | null) {
        this._orderTypeId = value;
    }
    
    public get orderType(): string | null {
        return this._orderType;
    }

    public set orderType(value: string | null) {
        this._orderType = value;
    }

    public get departmentId(): string | null {
        return this._departmentId;
    }

    public set departmentId(value: string | null) {
        this._departmentId = value;
    }
    
    public get department(): string | null {
        return this._department;
    }

    public set department(value: string | null) {
        this._department = value;
    }
    
    public get localOrder(): boolean | null {
        return this._localOrder;
    }

    public set localOrder(value: boolean | null) {
        this._localOrder = value;
    }

    public get currencyCode(): string | null {
        return this._currencyCode;
    }

    public set currencyCode(value: string | null) {
        this._currencyCode = value;
    }

    public get subject(): string | null {
        return this._subject;
    }

    public set subject(value: string | null) {
        this._subject = value;
    }
    
    public get supplierReference(): string | null {
        return this._supplierReference;
    }

    public set supplierReference(value: string | null) {
        this._supplierReference = value;
    }
    
    public get supplierContact(): string | null {
        return this._supplierContact;
    }

    public set supplierContact(value: string | null) {
        this._supplierContact = value;
    }
    
    public get budgetAccountNo(): string | null {
        return this._budgetAccountNo;
    }

    public set budgetAccountNo(value: string | null) {
        this._budgetAccountNo = value;
    }
    
    public get portCode(): string | null {
        return this._portCode;
    }

    public set portCode(value: string | null) {
        this._portCode = value;
    }

    public get incoTerm(): string | null {
        return this._incoTerm;
    }

    public set incoTerm(value: string | null) {
        this._incoTerm = value;
    }
    
    public get incoTermPlace(): string | null {
        return this._incoTermPlace;
    }

    public set incoTermPlace(value: string | null) {
        this._incoTermPlace = value;
    }

    public get payTerm(): string | null {
        return this._payTerm;
    }

    public set payTerm(value: string | null) {
        this._payTerm = value;
    }

    public get shipRequestedDeliveryDate(): Date | null {
        return this._shipRequestedDeliveryDate;
    }

    public set shipRequestedDeliveryDate(value: Date | null) {
        this._shipRequestedDeliveryDate = value;
    }

    public get estimatedDeliveryDate(): Date | null {
        return this._estimatedDeliveryDate;
    }

    public set estimatedDeliveryDate(value: Date | null) {
        this._estimatedDeliveryDate = value;
    }

    public get deliveryAddress(): string | null {
        return this._deliveryAddress;
    }

    public set deliveryAddress(value: string | null) {
        this._deliveryAddress = value;
    }

    public get approvedBy(): string | null {
        return this._approvedBy;
    }

    public set approvedBy(value: string | null) {
        this._approvedBy = value;
    }

    public get handledBy(): string | null {
        return this._handledBy;
    }

    public set handledBy(value: string | null) {
        this._handledBy = value;
    }

    public get createdDate(): Date | null {
        return this._createdDate;
    }

    public set createdDate(value: Date | null) {
        this._createdDate = value;
    }

    public get shipApprovedDate(): Date | null {
        return this._shipApprovedDate;
    }

    public set shipApprovedDate(value: Date | null) {
        this._shipApprovedDate = value;
    }

    public get shipReapprovedDate(): Date | null {
        return this._shipReapprovedDate;
    }

    public set shipReapprovedDate(value: Date | null) {
        this._shipReapprovedDate = value;
    }

    public get shipOrderedDate(): Date | null {
        return this._shipOrderedDate;
    }

    public set shipOrderedDate(value: Date | null) {
        this._shipOrderedDate = value;
    }

    public get receivedOfficeDate(): Date | null {
        return this._receivedOfficeDate;
    }

    public set receivedOfficeDate(value: Date | null) {
        this._receivedOfficeDate = value;
    }

    public get postponedToDate(): Date | null {
        return this._postponedToDate;
    }

    public set postponedToDate(value: Date | null) {
        this._postponedToDate = value;
    }

    public get requisitionApprovedDate(): Date | null {
        return this._requisitionApprovedDate;
    }

    public set requisitionApprovedDate(value: Date | null) {
        this._requisitionApprovedDate = value;
    }

    public get rfqSentDate(): Date | null {
        return this._rfqSentDate;
    }

    public set rfqSentDate(value: Date | null) {
        this._rfqSentDate = value;
    }

    public get awaitingApproval(): Date | null {
        return this._awaitingApproval;
    }

    public set awaitingApproval(value: Date | null) {
        this._awaitingApproval = value;
    }

    public get approvedDate(): Date | null {
        return this._approvedDate;
    }

    public set approvedDate(value: Date | null) {
        this._approvedDate = value;
    }

    public get officeOrderedDate(): Date | null {
        return this._officeOrderedDate;
    }

    public set officeOrderedDate(value: Date | null) {
        this._officeOrderedDate = value;
    }

    public get remindedDate(): Date | null {
        return this._remindedDate;
    }

    public set remindedDate(value: Date | null) {
        this._remindedDate = value;
    }

    public get confirmedDate(): Date | null {
        return this._confirmedDate;
    }

    public set confirmedDate(value: Date | null) {
        this._confirmedDate = value;
    }

    public get deliveredAgentDate(): Date | null {
        return this._deliveredAgentDate;
    }

    public set deliveredAgentDate(value: Date | null) {
        this._deliveredAgentDate = value;
    }

    public get sentFromAgentDate(): Date | null {
        return this._sentFromAgentDate;
    }

    public set sentFromAgentDate(value: Date | null) {
        this._sentFromAgentDate = value;
    }

    public get deliveredPoolDate(): Date | null {
        return this._deliveredPoolDate;
    }

    public set deliveredPoolDate(value: Date | null) {
        this._deliveredPoolDate = value;
    }

    public get sentFromPoolDate(): Date | null {
        return this._sentFromPoolDate;
    }

    public set sentFromPoolDate(value: Date | null) {
        this._sentFromPoolDate = value;
    }

    public get partlyDeliveredDate(): Date | null {
        return this._partlyDeliveredDate;
    }

    public set partlyDeliveredDate(value: Date | null) {
        this._partlyDeliveredDate = value;
    }

    public get onboardDate(): Date | null {
        return this._onboardDate;
    }

    public set onboardDate(value: Date | null) {
        this._onboardDate = value;
    }

    public get invoiceDate(): Date | null {
        return this._invoiceDate;
    }

    public set invoiceDate(value: Date | null) {
        this._invoiceDate = value;
    }

    public get invoiceApprovedDate(): Date | null {
        return this._invoiceApprovedDate;
    }

    public set invoiceApprovedDate(value: Date | null) {
        this._invoiceApprovedDate = value;
    }

    public get cancelledDate(): Date | null {
        return this._cancelledDate;
    }

    public set cancelledDate(value: Date | null) {
        this._cancelledDate = value;
    }

    public get finishedDate(): Date | null {
        return this._finishedDate;
    }

    public set finishedDate(value: Date | null) {
        this._finishedDate = value;
    }

    public get changedDate(): Date | null {
        return this._changedDate;
    }

    public set changedDate(value: Date | null) {
        this._changedDate = value;
    }

    public get footerText(): string | null {
        return this._footerText;
    }

    public set footerText(value: string | null) {
        this._footerText = value;
    }

    public get ihmStatus(): string | null {
        return this._ihmStatus;
    }

    public set ihmStatus(value: string | null) {
        this._ihmStatus = value;
    }
    
    public get costProjectId(): string | null {
        return this._costProjectId;
    }

    public set costProjectId(value: string | null) {
        this._costProjectId = value;
    }

    public get vesselId(): number | null {
        return this._vesselId;
    }

    public set vesselId(value: number | null) {
        this._vesselId = value;
    }

    public get vesselCode(): string | null {
        return this._vesselCode;
    }

    public set vesselCode(value: string | null) {
        this._vesselCode = value;
    }

    public get vesselName(): string | null {
        return this._vesselName;
    }

    public set vesselName(value: string | null) {
        this._vesselName = value;
    }

    public get supplierId(): string | null {
        return this._supplierId;
    }

    public set supplierId(value: string | null) {
        this._supplierId = value;
    }

    public get supplierName(): string | null {
        return this._supplierName;
    }

    public set supplierName(value: string | null) {
        this._supplierName = value;
    }

    public get agentId(): string | null {
        return this._agentId;
    }

    public set agentId(value: string | null) {
        this._agentId = value;
    }

    public get agentName(): string | null {
        return this._agentName;
    }

    public set agentName(value: string | null) {
        this._agentName = value;
    }

    public get statusDate(): Date | null {
        return this._statusDate;
    }

    public set statusDate(value: Date | null) {
        this._statusDate = value;
    }

    public get statusText(): string | null {
        return this._statusText;
    }

    public set statusText(value: string | null) {
        this._statusText = value;
    }

    public get total(): number | null {
        return this._total;
    }

    public set total(value: number | null) {
        this._total = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): Order | null {

        const orderId: string | null = safeParseNullDefault<string>(json?.orderId, '');
        const orderYear: number | null = safeParseNullDefault<number>(json?.orderYear, 0);
        const orderNo: number | null = safeParseNullDefault<number>(json?.orderNo, 0);
        const orderPart: number | null = safeParseNullDefault<number>(json?.orderPart, 0);
        const orderRef: string | null = safeParseNullDefault<string>(json?.orderRef, '');
        const priorityId: number | null = safeParseNullDefault<number>(json?.priorityId, 0);
        const priority: string | null = safeParseNullDefault<string>(json?.priority, '');
        const priorityColor: string | null = safeParseNullDefault<string>(json?.priorityColor, '');
        const orderTypeId: string | null = safeParseNullDefault<string>(json?.orderTypeId, '');
        const orderType: string | null = safeParseNullDefault<string>(json?.orderType, '');
        const departmentId: string | null = safeParseNullDefault<string>(json?.departmentId, '');
        const department: string | null = safeParseNullDefault<string>(json?.department, '');
        const localOrder: boolean | null = safeParseNullDefault<boolean>(json?.localOrder, false);
        const currencyCode: string | null = safeParseNullDefault<string>(json?.currencyCode, '');
        const subject: string | null = safeParseNullDefault<string>(json?.subject, '');
        const supplierReference: string | null = safeParseNullDefault<string>(json?.supplierReference, '');
        const supplierContact: string | null = safeParseNullDefault<string>(json?.supplierContact, '');
        const budgetAccountNo: string | null = safeParseNullDefault<string>(json?.budgetAccountNo, '');
        const portCode: string | null = safeParseNullDefault<string>(json?.portCode, '');
        const incoTerm: string | null = safeParseNullDefault<string>(json?.incoTerm, '');
        const incoTermPlace: string | null = safeParseNullDefault<string>(json?.incoTermPlace, '');
        const payTerm: string | null = safeParseNullDefault<string>(json?.payTerm, '');
        const shipRequestedDeliveryDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.shipRequestedDeliveryDate, ''));
        const estimatedDeliveryDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.estimatedDeliveryDate, ''));
        const deliveryAddress: string | null = safeParseNullDefault<string>(json?.deliveryAddress, '');
        const approvedBy: string | null = safeParseNullDefault<string>(json?.approvedBy, '');
        const handledBy: string | null = safeParseNullDefault<string>(json?.handledBy, '');
        const createdDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.createdDate, ''));
        const shipApprovedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.shipApprovedDate, ''));
        const shipReapprovedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.shipReapprovedDate, ''));
        const shipOrderedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.shipOrderedDate, ''));
        const receivedOfficeDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.receivedOfficeDate, ''));
        const postponedToDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.postponedToDate, ''));
        const requisitionApprovedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.requisitionApprovedDate, ''));
        const rfqSentDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.rfqSentDate, ''));
        const awaitingApproval: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.awaitingApproval, ''));
        const approvedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.approvedDate, ''));
        const officeOrderedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.officeOrderedDate, ''));
        const remindedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.remindedDate, ''));
        const confirmedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.confirmedDate, ''));
        const deliveredAgentDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.deliveredAgentDate, ''));
        const sentFromAgentDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.sentFromAgentDate, ''));
        const deliveredPoolDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.deliveredPoolDate, ''));
        const sentFromPoolDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.sentFromPoolDate, ''));
        const partlyDeliveredDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.partlyDeliveredDate, ''));
        const onboardDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.onboardDate, ''));
        const invoiceDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.invoiceDate, ''));
        const invoiceApprovedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.invoiceApprovedDate, ''));
        const cancelledDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.cancelledDate, ''));
        const finishedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.finishedDate, ''));
        const changedDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.changedDate, ''));
        const footerText: string | null = safeParseNullDefault<string>(json?.footerText, '');
        const ihmStatus: string | null = safeParseNullDefault<string>(json?.ihmStatus, '');
        const costProjectId: string | null = safeParseNullDefault<string>(json?.costProjectId, '');
        const vesselId: number | null = safeParseNullDefault<number>(json?.vesselId, 0);
        const vesselCode: string | null = safeParseNullDefault<string>(json?.vesselCode, '');
        const vesselName: string | null = safeParseNullDefault<string>(json?.vesselName, '');
        const supplierId: string | null = safeParseNullDefault<string>(json?.supplierId, '');
        const supplierName: string | null = safeParseNullDefault<string>(json?.supplierName, '');
        const agentId: string | null = safeParseNullDefault<string>(json?.agentId, '');
        const agentName: string | null = safeParseNullDefault<string>(json?.agentName, '');
        const statusDate: Date | null = datetimeFromApiParser(safeParseNullDefault<string>(json?.statusDate, ''));
        const statusText: string | null = safeParseNullDefault<string>(json?.statusText, '');
        const total: number | null = safeParseNullDefault<number>(json?.total, 0);

        if (orderId === null) {
            return null;
        }

        return new Order(orderId, orderYear, orderNo, orderPart, orderRef, priorityId, priority, priorityColor, orderTypeId, orderType, departmentId, department, localOrder, currencyCode, subject, supplierReference, supplierContact, budgetAccountNo, portCode, incoTerm, incoTermPlace, payTerm, shipRequestedDeliveryDate, estimatedDeliveryDate, deliveryAddress, approvedBy, handledBy, createdDate, shipApprovedDate, shipReapprovedDate, shipOrderedDate, receivedOfficeDate, postponedToDate, requisitionApprovedDate, rfqSentDate, awaitingApproval, approvedDate, officeOrderedDate, remindedDate, confirmedDate, deliveredAgentDate, sentFromAgentDate, deliveredPoolDate, sentFromPoolDate, partlyDeliveredDate, onboardDate, invoiceDate, invoiceApprovedDate, cancelledDate, finishedDate, changedDate, footerText, ihmStatus, costProjectId, vesselId, vesselCode, vesselName, supplierId, supplierName, agentId, agentName, statusDate, statusText, total);
    }

    public getPriorityColor(appTheme: AppTheme): string {

        if (this.priority === 'Normal need') {
            return appTheme === AppTheme.LIGHT_MODE ? '#000000' : '#FFFFFF';
        } else if (this.priority === 'Great need') {
            return appTheme === AppTheme.LIGHT_MODE ? '#0000FF' : '#80B0FF';
        } else if (this.priority === 'Urgent need') {
            return '#FF0000';
        } else if (this.priority === 'Provision & Stores') {
            return appTheme === AppTheme.LIGHT_MODE ? '#000000' : '#FFFFFF';
        } else if (this.priority === 'Other') {
            return appTheme === AppTheme.LIGHT_MODE ? '#000000' : '#FFFFFF';
        } else {
            return appTheme === AppTheme.LIGHT_MODE ? '#000000' : '#FFFFFF';
        }
    }
}

export default Order;